<nav class="navbar navbar-expand-sm header-nav-menu p-0 tab-bar">
    <div class="pl-0 col-md-12 col-lg-12 col-xl-9">
        <div>
            <ul class="navbar-nav ml-0 navHold">
                <li class="nav-item">
                    <a class="nav-link" routerLink="/overview" routerLinkActive="active">{{labels.overview}}</a>
                </li>
                <li class="nav-item" *ngIf="isAdmin == 'true'">
                    <a class="nav-link" routerLink="/statistics" routerLinkActive="active">{{labels.dashboard}}</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/support" routerLinkActive="active">{{labels.support}}</a>
                </li>
            </ul>
        </div>
    </div>
</nav>